import { createSlice } from "@reduxjs/toolkit";

/**
 * Home Slice of the Redux Store
 */
export const HomeSlice = createSlice({
  name: "home",
  initialState: {
    selectedDates: {
      start: { _d: new Date() },
      end: { _d: new Date() }
    },
    volteCallsCount: null,
    autoRefresh: false,
  },
  reducers: {
    setSelectedDates: (state, action) => {
      state.selectedDates = action.payload;
    },
    setVolteCallsCount: (state, action) => {
      state.volteCallsCount = action.payload;
    },
    setAutoRefresh: (state, action) => {
      state.autoRefresh = action.payload;
    },
  },
});

// this is for dispatch
export const {
  setSelectedDates, setVolteCallsCount, setAutoRefresh
} = HomeSlice.actions;

// this is for configureStore
export default HomeSlice.reducer;
